/**
 * Created by pandemio on 3/29/19.
 */
import React from 'react';
import Select from 'react-select';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of the roles
 */
class SelectorRoles extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state = {
            options: [], // The options to fill the selection
            value: null
        };
    }

    /** Handle the updates
     * We cannot find a concrete response why this is needed here meanwhile the other selector components are not needed.
     * @param nextProps
     */
    componentWillReceiveProps(props){

        this.setState({value: props.roleId}, ()=>{
            this.callData();
        });
    }

    /**
     * Call the data API
     */
    callData(){
        // This is promise
        let apiCall = ApiCalls.getRoles();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{

            let dataReturned = data.Roles;
            // Translate the first selection
            arrOptions.push(
                <option key={"0"} value={"0"}>
                    <Translate id="roles.select-role" options={{renderInnerHtml: false}}/>
                </option>);

            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++) {
                arrOptions.push({
                        value: dataReturned[i].Id,
                        label: dataReturned[i].Name
                    }
                );
            }
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (object) => {
        this.setState({value: object.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Select
                value={this.state.options.filter(option => option.value === this.state.value)}
                isDisabled={this.state.disabled} options={this.state.options} name="roles"
                onChange={this.handleChange} placeholder=
                    {
                        <Translate id="roles.select-role" options={{renderInnerHtml: false}}/>
                    }
            />
        )
    }
}

export default SelectorRoles;